module.exports = __webpack_public_path__ + "img/dolen-perkins-valdez.4663172d.png";